import { render, staticRenderFns } from "./GroupName.vue?vue&type=template&id=7cb82d87&"
import script from "./GroupName.vue?vue&type=script&lang=js&"
export * from "./GroupName.vue?vue&type=script&lang=js&"
import style0 from "./GroupName.vue?vue&type=style&index=0&id=7cb82d87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports